import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save'; // Import the Save icon
import EditNoteIcon from '@mui/icons-material/EditNote';
import RefreshIcon from '@mui/icons-material/Refresh';


function PriceList() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, userId, token, logout]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item => item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);


    const fetchtableData = async () => {
        setLoading(true);

        // Check if token exists
        if (!token) {
            logout();
            history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            return;
        }

        try {
            const response = await fetchData('ItemRateCheckingApi', `/${companyId}`, token);

            if (response.responseCode === '1111') {
                setData(response.response_data);
                setFilteredData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error.message || error);

            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        deleteData('CategoryApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('CategoryApi', `${itemId}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [editItemId, setEditItemId] = useState(null);
    const [editedCategoryOrderNo, seteditedCategoryOrderNo] = useState(null);

    const handleEdit = (itemId, currentRouteSequenceNo) => {
        setEditItemId(itemId);
        seteditedCategoryOrderNo(currentRouteSequenceNo);
    };

    const handleCategoryNoChange = (event) => {
        seteditedCategoryOrderNo(event.target.value);
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const updatedData = {
            Id: editItemId,
            CategoryOrderNo: editedCategoryOrderNo,
            ModifiedBy: userId,
        };

        updateData('CategoryApi', `catogeryOrderNo/${editItemId}`, updatedData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                setIsLoading(false);
                // Reload the page after updating
                window.location.reload();

            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Item PriceList</title><style>');

        // Add your custom styles for printing
        printWindow.document.write(`
            body {
                font-family: Arial, sans-serif;
            }
            h3 {
                text-align: center;
                font-size: 32px;
            }
            table {
                width: 100%;
                border-collapse: collapse;
                margin: 20px 0;
            }
            th, td {
                border: 1px solid #ccc;
                padding: 8px;
                text-align: left;
            }
            th {
                background-color: #f4f4f4;
                font-weight: bold;
                color: darkred;
            }
            tr.category-header {
                background-color: #e0e0e0;
            }
            tr.category-header td {
                text-align: center;
                font-weight: bold;
                color: darkblue;
                font-size: 16px;
            }
            .inactiveRow {
                opacity: 0.5;
            }
        `);

        printWindow.document.write('</style></head><body>');
        printWindow.document.write('<h3>Item PriceList</h3>');

        // Start the table
        printWindow.document.write('<table>');

        // Iterate through the filteredData to generate table rows
        filteredData
            .sort((a, b) => {
                if (a.categoryOrderNo === b.categoryOrderNo) {
                    return a.bagWeight - b.bagWeight;
                }
                return a.categoryOrderNo - b.categoryOrderNo;
            })
            .reduce((acc, item) => {
                if (!acc.categoriesAdded.includes(item.categoryId)) {
                    // Category header
                    acc.rows.push(`
                        <tr class="category-header">
                            <td colspan="8">${item.category}</td>
                        </tr>
                    `);

                    // Price headers row for this category
                    acc.rows.push(`
                        <tr class="category-header">
                            <td>Item Name</td>
                             <td>MRP</td>
                              <td>Mill Rate</td>
                            <td>A1 Price</td>
                            <td>A Price</td>
                            <td>B Price</td>
                            <td>C Price</td>
                            <td>D Price</td>
                           
                        </tr>
                    `);

                    acc.categoriesAdded.push(item.categoryId);
                }

                // Item rows
                acc.rows.push(`
                    <tr class="${item.isActive ? '' : 'inactiveRow'}">
                        <td>${item.name}</td>
                        <td style="text-align: right">${item.rate || '-'}</td>
                        <td style="text-align: right">${item.millRate || '-'}</td>
                        <td style="text-align: right">${item.a1price || '-'}</td>
                        <td style="text-align: right">${item.aprice || '-'}</td>
                        <td style="text-align: right">${item.bprice || '-'}</td>
                        <td style="text-align: right">${item.cprice || '-'}</td>
                        <td style="text-align: right">${item.dprice || '-'}</td>
                    </tr>
                    `);


                return acc;
            }, { rows: [], categoriesAdded: [] }).rows.forEach(row => {
                printWindow.document.write(row);
            });

        // Close the table and body
        printWindow.document.write('</table>');
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    };


    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '95%' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>PRICE LIST</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <div className="w-1/4 mb-2 flex ml-2" style={{ marginLeft: '10px', marginTop: '10px' }}>
                    <input
                        type="text"
                        placeholder="Search by variant name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                </div>
                <Button
                    onClick={handlePrint}
                    style={{
                        backgroundColor: 'darkmagenta',
                        color: 'whitesmoke',
                        fontWeight: 'bold',
                        height: '25px',
                        marginLeft: '4px',
                        marginTop: '12px'
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Print"}
                </Button>

                {/* <div className='w-1/4 mb-2 flex' style={{marginLeft: '8px' }}>
                    <input
                        type="text"
                        placeholder="Search by variant name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    />
                </div>
                <Button onClick={handlePrint} style={{ background: 'darkmagenta', color: 'whitesmoke', fontWeight: 'bolder', height: '25px', marginLeft: '2px' }} disabled={isLoading}>
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "Print"}
                </Button> */}

            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '550px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>

                        <TableBody style={{ backgroundColor: 'white' }}>
                            {filteredData
                                // Sort categories by `categoryOrderNo` and then items by `bagweight`
                                .sort((a, b) => {
                                    if (a.categoryOrderNo === b.categoryOrderNo) {
                                        return a.bagWeight - b.bagWeight;
                                    }
                                    return a.categoryOrderNo - b.categoryOrderNo;
                                })
                                .reduce((acc, item) => {
                                    // Check if the category header has already been added for this item
                                    if (!acc.categoriesAdded.includes(item.categoryId)) {
                                        // Add the category header row
                                        acc.rows.push(
                                            <TableRow key={`category-${item.categoryId}`} style={{ backgroundColor: '#f0f0f0' }}>
                                                <TableCell colSpan={10} sx={{ padding: '10px', fontWeight: 'bold', color: 'darkblue', fontSize: '16px', textAlign: 'center' }}>
                                                    {item.category}
                                                </TableCell>
                                            </TableRow>
                                        );

                                        // Add the price headers row for this category
                                        acc.rows.push(
                                            <TableRow key={`category-header-${item.categoryId}`} style={{ backgroundColor: '#e0e0e0' }}>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'darkred', textAlign: 'left', paddingLeft: '10px' }}>Item Name</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'darkred', textAlign: 'center', paddingLeft: '10px' }}>MRP</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'darkred', textAlign: 'center', paddingLeft: '10px' }}>Mill Rate</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'darkred', textAlign: 'center', paddingLeft: '10px' }}>A1 Price</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'darkred', textAlign: 'center', paddingLeft: '10px' }}>A Price</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'darkred', textAlign: 'center', paddingLeft: '10px' }}>B Price</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'darkred', textAlign: 'center', paddingLeft: '10px' }}>C Price</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'darkred', textAlign: 'center', paddingLeft: '10px' }}>D Price</TableCell>
                                            </TableRow>
                                        );

                                        // Track that this category has been added
                                        acc.categoriesAdded.push(item.categoryId);
                                    }

                                    // Add each item row with all prices displayed
                                    acc.rows.push(
                                        <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'}>
                                            <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black', textAlign: 'left' }}>{item.name}</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black', textAlign: 'center' }}>{item.rate || '-'}</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black', textAlign: 'center' }}>{item.millRate || '-'}</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black', textAlign: 'center' }}>{item.a1price || '-'}</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black', textAlign: 'center' }}>{item.aprice || '-'}</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black', textAlign: 'center' }}>{item.bprice || '-'}</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black', textAlign: 'center' }}>{item.cprice || '-'}</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black', textAlign: 'center' }}>{item.dprice || '-'}</TableCell>

                                        </TableRow>
                                    );

                                    return acc;
                                }, { rows: [], categoriesAdded: [] }).rows}
                        </TableBody>


                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete ?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div >
        </div >
    );
}

export default PriceList;

